import { Outlet } from "react-router-dom";

export const EmptyLayout = () => {
  return <Outlet />;
};
